import React from 'react'
import className from 'classnames/bind'
import dayjs from 'dayjs'

import style from './MyhousePtpArticleItem.module.scss'

import { TRADE } from '@Root/contants'
import { NCLICK } from '@Root/contants/lcs'
import { handleNclickMix } from '@Helpers/nclick'

const cx = className.bind(style)

type Props = {
  articleName?: any
  articleNo?: any
  articleRealEstateTypeName?: any
  buildingName?: any
  area1?: any
  area2?: any
  floorInfo?: any
  direction?: any
  articleConfirmYmd?: any
  tradeTypeName?: any
  dealOrWarrantPrc?: any
  isSamePtpArticle?: any
  tradeTypeCode?: any
  rentPrc?: any
}

const MyhousePtpArticleItem: React.FC<Props> = ({
  articleName,
  articleNo,
  articleRealEstateTypeName,
  buildingName,
  area1,
  area2,
  floorInfo,
  direction,
  articleConfirmYmd,
  tradeTypeName,
  dealOrWarrantPrc,
  isSamePtpArticle,
  tradeTypeCode,
  rentPrc,
}: Props) => {
  return (
    <li className={cx('myhouse_article_item')}>
      <a
        href={`${process.env.REACT_APP_PROPERTY_WEB_URL}/articles/${articleNo}`}
        className={cx('myhouse_item_link')}
        onClick={handleNclickMix(isSamePtpArticle ? NCLICK.MY_HOUSE.SAME_ARTICLE.LIST : NCLICK.MY_HOUSE.SIMILAR_ARTICLE.LIST)}
      >
        <strong className={cx('myhouse_title')}>
          {isSamePtpArticle ? (
            <>
              {articleName} {buildingName}
            </>
          ) : (
            <>{articleRealEstateTypeName}</>
          )}
        </strong>
        <div className={cx('myhouse_feature')}>
          <span className={cx('myhouse_feature_item')}>
            {area1}/{area2}㎡
          </span>
          <span className={cx('myhouse_feature_item')}>{floorInfo}층</span>
          {direction && <span className={cx('myhouse_feature_item')}>{direction}</span>}
        </div>
        <div className={cx('myhouse_info')}>
          <em className={cx('myhouse_confirm')}>확인매물 {dayjs(articleConfirmYmd).format('YY.MM.DD.')}</em>
          <strong className={cx('myhouse_price')}>
            {tradeTypeCode === TRADE.RENT ? (
              <>
                {tradeTypeName} {dealOrWarrantPrc}/{rentPrc}
              </>
            ) : (
              <>
                {tradeTypeName} {dealOrWarrantPrc}
              </>
            )}
          </strong>
        </div>
      </a>
    </li>
  )
}

export default MyhousePtpArticleItem
